// plugins/element-plus-icons.js
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

export default defineNuxtPlugin(nuxtApp => {
  // 遍历ElementPlusIconsVue对象，并注册所有图标为全局组件
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    nuxtApp.vueApp.component(key, component)
  }
})